import GuestDeviceConfirm from './GuestDeviceConfirm';

export default GuestDeviceConfirm;
